import { Breakpoint } from './types';
import defaultBreakpoints from './breakpoints';

const getTheme = (breakpoints = defaultBreakpoints) => {
    return {
        mixBlendMode: 'multiply' as 'multiply' | 'normal' | 'screen',
        palette: {
            primary: {
                '100': '#FEE4D9',
                '200': '#FDC4B4',
                '300': '#F99C8E',
                '400': '#F47670',
                '500': '#ED434B',
                '600': '#CB3046',
                '700': '#AA2140',
                '800': '#891539',
                '900': '#710C35',
            },
            neutral: {
                '100': '#F8F7F3',
                '200': '#F0EFE8',
                '300': '#EAE8DE',
                '400': '#DEDCCF',
                '500': '#D2D0C2',
                '600': '#CAC8B9',
                '700': '#BDBBAB',
                '800': '#AEAC9A',
                '900': '#A1A08E',
            },
            greys: {
                '100': '#FFFFFF',
                '200': '#F5F5F5',
                '300': '#EBEBEB',
                '400': '#C5C5C5',
                '500': '#8C8C8C',
                '600': '#646464',
                '700': '#404040',
                '800': '#372E2F',
                '900': '#251418',
            },
            accent: {
                '100': '#E6FCEE',
                '200': '#CDF9E1',
                '300': '#AEEDD1',
                '400': '#94DDC3',
                '500': '#70C8B0',
                '600': '#52AC9C',
                '700': '#3B9089',
                '800': '#277174',
                '900': '#18565F',
            },
            notification: '#FE6B7D',
        },
        typography: {
            color: '#404040',
            t10: {
                fontFamily: 'La Nord',
                fontSize: '6rem',
                fontWeight: 500,
                lineHeight: 1.2,
            },
            t15: {
                fontFamily: 'La Nord',
                fontSize: '4.8rem',
                fontWeight: 500,
                lineHeight: 1.2,
            },
            t20: {
                fontFamily: 'La Nord',
                fontSize: '3.6rem',
                fontWeight: 400,
                lineHeight: 1.15,
            },
            t30: {
                fontFamily: 'La Nord',
                fontSize: '2.8rem',
                fontWeight: 400,
                lineHeight: 1.15,
            },
            t31: {
                fontFamily: 'La Nord',
                fontSize: '2.8rem',
                fontWeight: 400,
                lineHeight: 1.4,
            },
            t40: {
                fontFamily: 'La Nord',
                fontSize: '2.4rem',
                fontWeight: 500,
                lineHeight: 1.15,
            },
            t41: {
                fontFamily: 'La Nord',
                fontSize: '2.4rem',
                fontWeight: 400,
                lineHeight: 1.15,
            },
            t50: {
                fontFamily: 'La Nord',
                fontSize: '2rem',
                fontWeight: 400,
                lineHeight: 1.35,
            },
            t60: {
                fontFamily: 'La Nord',
                fontSize: '1.6rem',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            t61: {
                fontFamily: 'La Nord',
                fontSize: '1.6rem',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            t70: {
                fontFamily: 'Inter',
                fontSize: '1.4rem',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            t71: {
                fontFamily: 'Inter',
                fontSize: '1.4rem',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            t80: {
                fontFamily: 'Inter',
                fontSize: '1.2rem',
                fontWeight: 600,
                lineHeight: 1.5,
            },
            t81: {
                fontFamily: 'Inter',
                fontSize: '1.2rem',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            t90: {
                fontFamily: 'Inter',
                fontSize: '1rem',
                fontWeight: 600,
                lineHeight: 1.5,
            },
        },
        breakpoints: {
            up: (key: Breakpoint) => `@media (min-width: ${breakpoints[key]}px)`,
            down: (key: Breakpoint) => `@media (max-width: ${breakpoints[key]}px)`,
        },
        zIndex: { modal: 2000 },
    };
};

export default getTheme;
